import api from '@/plugins/api'
import {search} from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
const store = 'search'

export default {
  state: () => ({
    searchResult: null,
    isSearchLoading: false,
    isShowSearchResult: false,
    isShowSearchHint: false
  }),
  actions: {
    async getSearch (context, query) {
      context.dispatch('setSearchLoading', true)
      const response = await api.get(`${search.search}?${query}`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'searchResult', data: response.data })
        context.dispatch('setSearchLoading', false)
        context.dispatch('setSearchLoaded', true)
      }
    },

    setSearchHint (context, hint) {
      if (hint) {
        context.commit('SET_DATA', { store, state: 'searchResult', data: null })
      }
      context.commit('SET_DATA', { store, state: 'isShowSearchHint', data: hint })
    },

    setSearchLoading (context, loading) {
      context.commit('SET_DATA', { store, state: 'isSearchLoading', data: loading })
    },
    setSearchLoaded (context, loaded) {
      context.commit('SET_DATA', { store, state: 'isShowSearchResult', data: loaded })
    }
  }
}


